/**
 * Recommended add-ons carousel (product page).
 * Native scroll-snap track; the arrows only scroll it and are hidden when every slide already fits.
 */
if (!customElements.get('product-addons')) {
  class ProductAddons extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prevButton = this.querySelector('[data-prev-button]');
      this.nextButton = this.querySelector('[data-next-button]');
      this.arrows = this.querySelector('[data-arrows]');
      if (!this.track || !this.prevButton || !this.nextButton) return;

      this.onScroll = () => this.update();
      this.onPrev = () => this.scrollPage(-1);
      this.onNext = () => this.scrollPage(1);

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.prevButton.addEventListener('click', this.onPrev);
      this.nextButton.addEventListener('click', this.onNext);

      this.resizeObserver = new ResizeObserver(this.onScroll);
      this.resizeObserver.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      if (!this.track) return;
      this.track.removeEventListener('scroll', this.onScroll);
      this.prevButton.removeEventListener('click', this.onPrev);
      this.nextButton.removeEventListener('click', this.onNext);
      this.resizeObserver?.disconnect();
    }

    get isRtl() {
      return getComputedStyle(this.track).direction === 'rtl';
    }

    scrollPage(direction) {
      const slide = this.track.querySelector('[data-slide]');
      if (!slide) return;

      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = slide.getBoundingClientRect().width + gap;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.track.scrollBy({
        left: direction * step * (this.isRtl ? -1 : 1),
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const position = Math.abs(this.track.scrollLeft);

      if (this.arrows) this.arrows.hidden = max <= 1;
      this.prevButton.disabled = position <= 1;
      this.nextButton.disabled = position >= max - 1;
    }
  }

  customElements.define('product-addons', ProductAddons);
}
